import MuiInputLabel, { InputLabelProps } from '@mui/material/InputLabel'
import { Casing, TEXT_ROLE_CASING } from '@common/helpers/casing'
import cn from 'classnames'
import { formatChildren } from '../Text'
import styles from './InputLabel.module.scss'

interface IProps extends InputLabelProps {
  position?: 'vertical' | 'horizontal'
  /** Overrides the field label role's case. */
  casing?: Casing
}

const InputLabel = ({
  size = 'small',
  position = 'vertical',
  casing = TEXT_ROLE_CASING.fieldLabel,
  children,
  ...props
}: IProps) => {
  return (
    <MuiInputLabel
      {...props}
      className={cn(styles.inputLabel, props.className, {
        [styles.inputLabelMedium]: size === 'medium',
        [styles.inputLabelHorizontal]: position === 'horizontal',
      })}
    >
      {formatChildren(casing, children)}
    </MuiInputLabel>
  )
}

export default InputLabel
